import { gql } from '@apollo/client';

export const setDealProductManualTermMutation = gql`
  mutation setDealProductManualTerm($input: SetDealProductManualTermInputV2!) {
    setDealProductManualTerm(input: $input) {
      id
      deal_id
      product_catalog_id
      price
      cost
      term
      pen_session_id
      pen_rate_id
      pen_form_id
      pen_contract_number
      product_catalog {
        id
        slug
        name
      }
    }
  }
`;

export const selectDealProductVscRateMutation = gql`
  mutation selectDealProductVscRate($input: SelectDealProductVscRateInput!) {
    selectDealProductVscRate(input: $input) {
      vscDealProduct {
        id
        deal_id
        product_catalog_id
        price
        cost
        term
        coverage_type
        pen_session_id
        pen_rate_id
        pen_form_id
        product_catalog {
          id
          slug
          name
        }
      }
      paymentOptions {
        selectedPackageSlotIndex
      }
    }
  }
`;
